<ion-content>
    <section>
        <h3>Informations personelles</h3>
        <ion-list lines="none">
            <div>
                <p>Nom:</p>
                <p>{{ userInfos().fullname.split(' ')[0] }}</p>
            </div>
            <div>
                <p>Prénom:</p>
                <p>{{ userInfos().fullname.split(' ')[1] }}</p>
            </div>
            <div>
                <p>Formation:</p>
                <p></p>
            </div>
            <div>
                <p>Entreprise:</p>
                <p></p>
            </div>
            <div>
                <p>Mail:</p>
                <p>{{ userInfos().email }}</p>
            </div>
            <ion-button>
                Changer le mot de passe
            </ion-button>
        </ion-list>
    </section>
</ion-content>